import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { FinanceiroService } from '../../../services/financeiro.service';
import { AuthService } from '../../../services/auth.service';
import { LogVendaResponse } from '../../../models/financeiro.model';

@Component({
  selector: 'app-log-venda-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './log-venda-modal.html',
  styleUrls: ['./log-venda-modal.css']
})
export class LogVendaModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() idVenda: number | null = null;

  @Output() closed = new EventEmitter<void>();

  logs: LogVendaResponse[] = [];
  novaMensagem = '';

  isLoadingList = false;
  hasErrorList = false;
  isSaving = false;

  private readonly financeiroService = inject(FinanceiroService);
  private readonly authService = inject(AuthService);
  private readonly toastr = inject(ToastrService);
  private readonly cdr = inject(ChangeDetectorRef);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && this.isOpen) {
      this.novaMensagem = '';
      this.carregarLogs();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: Event): void {
    if (!this.isOpen || this.isSaving) {
      return;
    }
    event.preventDefault();
    this.fechar();
  }

  carregarLogs(): void {
    if (!this.idVenda) {
      return;
    }

    this.isLoadingList = true;
    this.hasErrorList = false;

    this.financeiroService.getLogsVendaByIdVenda(this.idVenda).subscribe({
      next: (data) => {
        this.logs = data ?? [];
        this.isLoadingList = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        const mensagem = error?.error?.message ?? 'Erro ao carregar o log da venda.';
        this.toastr.error(mensagem);
        this.hasErrorList = true;
        this.isLoadingList = false;
        this.cdr.detectChanges();
      }
    });
  }

  registrarLog(): void {
    const mensagem = this.novaMensagem.trim();
    if (!mensagem || !this.idVenda || this.isSaving) {
      return;
    }

    this.isSaving = true;
    this.cdr.detectChanges();

    const idUsuario = this.authService.getUser()?.id ?? 0;

    this.financeiroService.criarLogVenda({
      idVenda: this.idVenda,
      idUsuario,
      dataRegistro: null,
      mensagem
    }).subscribe({
      next: () => {
        this.isSaving = false;
        this.novaMensagem = '';
        this.toastr.success('Evento registrado com sucesso.');
        this.fechar();
      },
      error: (error) => {
        const mensagemErro = error?.error?.message ?? 'Erro ao registrar o evento.';
        this.toastr.error(mensagemErro);
        this.isSaving = false;
        this.cdr.detectChanges();
      }
    });
  }

  fechar(): void {
    if (this.isSaving) {
      return;
    }
    this.closed.emit();
  }
}
